import { render, staticRenderFns } from "./FollowingItem.vue?vue&type=template&id=2334130b&scoped=true&"
import script from "./FollowingItem.vue?vue&type=script&lang=ts&"
export * from "./FollowingItem.vue?vue&type=script&lang=ts&"
import style0 from "./FollowingItem.vue?vue&type=style&index=0&id=2334130b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334130b",
  null
  
)

export default component.exports